import React from 'react'
import Spinner from 'react-spinner'
import 'react-spinner/react-spinner.css'
import C from '../Const'
import PrintButton from '../PrintButton'
import { Col, Grid, Row } from '../react-bootstrap'
import ChartAssunzPerAnno from './ChartAssunzPerAnno'
import ChartAssunzPerCat from './ChartAssunzPerCat'
import ChartAssunzPerMese from './ChartAssunzPerMese'
import ChartSaldoCumulato from './ChartSaldoCumulato'
import ChartSaldoPerCat from './ChartSaldoPerCat'
import DateTitolo from './DateTitolo'
import './Main.css'
import RowTotali from './RowTotali'
import TableVariazioni from './TableVariazioni'

function MainProf(props) {
  const { filters, series, print, data, onDrillDownProf, hash } = props

  if (data == null || data.loading) {
    return <Spinner className="Main MainProf loading" />
  } else if (data.error) {
    return (
      <div className="Main MainProf error">
        {C.ERRORE}
        <pre>{data.error}</pre>
      </div>
    )
  }

  const { table_prof, assunz_per_prof, saldo_per_prof, year_bounds } = data

  return (
    <div className="Main MainProf">
      <Grid>
        <Row className="Main-title clearfix">
          <Col sm={12}>
            <h1>
              Domanda di lavoro dipendente per professioni
              <DateTitolo from={filters.from} to={filters.to} yearBounds={year_bounds} />
            </h1>
          </Col>
        </Row>

        <RowTotali {...props} />

        <Row>
          <Col md={6} className="chart-container">
            <h2 className="bar-chart">Variazione occupazionale complessiva</h2>
            <ChartSaldoPerCat
              series={series}
              chart_data={saldo_per_prof}
              onDrillDown={onDrillDownProf}
              print={print}
            />
          </Col>

          <Col md={6} className="chart-container">
            <h2 className="line-chart">Variazione occupazionale cumulata</h2>
            <ChartSaldoCumulato {...props} />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="chart-container">
            <h2 className="bar-chart">Numero di assunzioni</h2>
            <ChartAssunzPerCat
              series={series}
              chart_data={assunz_per_prof}
              onDrillDown={onDrillDownProf}
              print={print}
            />
          </Col>

          <Col md={6} className="chart-container">
            <h2 className="line-chart">Andamento delle assunzioni per anno</h2>
            <ChartAssunzPerAnno {...props} />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="chart-container">
            <h2 className="table-title">Le professioni più richieste</h2>
            <TableVariazioni
              filters={filters}
              series={series}
              table_data={table_prof}
              year_bounds={year_bounds}
            />
          </Col>

          <Col md={6} className="chart-container">
            <h2 className="col-chart">Stagionalità &ndash; Media assunzioni per mese</h2>
            <ChartAssunzPerMese {...props} />
          </Col>
        </Row>

        <Row>
          <Col md={12}>{print || <PrintButton app="prof" hash={hash} />}</Col>
        </Row>
      </Grid>
    </div>
  )
}

export default MainProf



// WEBPACK FOOTER //
// ./src/main/MainProf.js